import API, { APIResponse } from '../../../lib/commons/api'
import { UserBasic } from '../../../lib/functions/user'
import { DivisionDetail } from '../../../lib/functions/division'

export const PROGRAM_STATUSES = [
  'STANDBY',
  'INPROGRESS',
  'SUSPENDED',
  'COMPLETED',
] as const

export type ProgramStatus = (typeof PROGRAM_STATUSES)[number]

export type ProgramOverviewDto = {
  uuid: string
  code: string
  displayName: string
  status: ProgramStatus | null
  scheduledStartDate: string | null
  scheduledEndDate: string | null
  division: DivisionDetail | null
  programManager: UserBasic
  collaborators: UserBasic[]
  revision: string
  createdAt: string
  createdBy: UserBasic
  updatedAt: string
  updatedBy: UserBasic
  lockVersion: number
}

export const getPrograms = (): Promise<APIResponse> =>
  API.functional.request('GET', '/api/v1/programs', {}, true)
